import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styles from "./Faq.module.scss";
import { motion } from "framer-motion";
import { animatePage } from "../../animation/animationPage";
import { FaClipboardList, FaTools, FaHeadset } from "react-icons/fa";
import { FiArrowRight } from "react-icons/fi";

const Faq = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const actionTiles = [
    {
      key: "calibration-request",
      icon: <FaClipboardList />,
      title: t("calibration_request.title"),
      subtitle: t("calibration_request.transducers_desc"),
      cta: <FiArrowRight />,
      onClick: () => navigate("/private/calibration-request"),
    },
    {
      key: "sav",
      icon: <FaTools />,
      title: t("sav_request.title"),
      subtitle: t("faq.sav_subtitle"),
      cta: <FiArrowRight />,
      onClick: () => navigate("/private/sav-request"),
    },
    {
      key: "support",
      icon: <FaHeadset />,
      title: t("support_request.title"),
      subtitle: t("faq.support_subtitle"),
      cta: <FiArrowRight />,
      onClick: () => navigate("/private/support-request"),
    },
  ];

  const videoList = [
    { url: "https://www.youtube.com/embed/CA-OXasI1CE", title: t("faq.video_install") },
    { url: "https://www.youtube.com/embed/4sBqZDpN8Pk", title: t("faq.video_free_field") },
    { url: "https://www.youtube.com/embed/RQqMR2s5hos", title: t("faq.video_headphones") },
    { url: "https://www.youtube.com/embed/ZUtmdMd3VkI", title: t("faq.video_inserts") },
    { url: "https://www.youtube.com/embed/QUdhPwiYjrI", title: t("faq.video_free_field_install") },
    { url: "https://www.youtube.com/embed/PttdrPRYWik?si=r-_VH3Bbivk4QREt", title: t("faq.video_spatial") },
  ];

  return (
    <motion.div
      className={styles.container}
      variants={animatePage}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <div className={styles.section}>
        {/* ── Tuiles d'action ── */}
        <div className={styles.actionGrid}>
          {actionTiles.map((tile) => (
            <button
              key={tile.key}
              type="button"
              className={styles.actionTile}
              onClick={tile.onClick}
            >
              <span className={styles.actionIcon}>{tile.icon}</span>
              <span className={styles.actionTexts}>
                <span className={styles.actionTitle}>{tile.title}</span>
                <span className={styles.actionSubtitle}>{tile.subtitle}</span>
              </span>
              <span className={styles.actionCta}>{tile.cta}</span>
            </button>
          ))}
        </div>

        {/* ── Vidéos ── */}
        <div className={styles.grid}>
          {videoList.map((video, index) => (
            <div key={index} className={styles.card}>
              <iframe
                className={styles.media}
                src={video.url}
                title={video.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
              <div className={styles.cardTitle}>{video.title}</div>
            </div>
          ))}
        </div>
      </div>
    </motion.div>
  );
};

export default Faq;
